import { z } from 'zod';

export const batchSelectionSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal('explicit'),
    ids: z.array(z.string()).min(1)
  }),
  z.object({
    mode: z.literal('filter'),
    workflowId: z.string(),
    filter: z.unknown().optional(),
    excludeIds: z.array(z.string()).optional()
  })
]);

export type BatchSelection = z.infer<typeof batchSelectionSchema>;
